<template>
  <div class="relative">
    <input
      :type="type"
      class="form-control"
      :class="[{ invalid: error, 'border-success': successMessage }, classList]"
      :placeholder="placeholder"
      :value="isMoney ? _formatCurrencyInput(model) : model"
      :error="error"
      :maxlength="maxlength"
      :minlength="minlength"
      :disabled="disabled"
      @input="handleInput($event)"
      @keydown="validateFormat($event)"
      @keyup="validateValue($event)"
      @paste="onPaste($event)"
      @focus="onFocus($event)"
      @blur="onBlur($event)"
    />
    <slot name="icon" />
    <span class="error-message" v-if="error">{{ errorMessage }}</span>
    <span class="success-message" v-if="successMessage">{{ successMessage }}</span>
  </div>
</template>

<script>
import { _formatCurrencyInput } from "@/_helpers/function.js";
export default {
  props: {
    classList: String,
    maxlength: String,
    minlength: String,
    errorMessage: String,
    successMessage: String,
    placeholder: String,
    type: String,
    model: [String, Number],
    error: Boolean,
    regex: RegExp,
    disabled: Boolean,
    notSmallThan: Number,
    maxValue: Number,
    isMoney: Boolean,
    isUpperCase: Boolean,
    isLowerCase: Boolean,
    isRealtimeValidate: Boolean,
    action: Function
  },
  data() {
    return {};
  },
  watch: {
    maxValue(value) {
      if (this.model) {
        this.$emit("update:model", null);
      }
    }
  },
  methods: {
    validateValue(e) {
      let value = e.target.value;
      if (value && this.isMoney) {
        value = value.replace(/\./g, "");
      }
      if (value && this.maxValue) {
        value = Math.min(this.maxValue, value);
      }
      if (
        (value || value === 0) &&
        (this.notSmallThan || this.notSmallThan === 0)
      ) {
        value = Math.max(this.notSmallThan + 1, value);
      }
      e.target.value = this.isMoney ? this._formatCurrencyInput(value) : value;
      this.$emit("update:model", value);
    },
    async onPaste(evt) {
      // let text = "";
      // if (!this.regex || this.regex == "/^[0-9]*$/") {
      //   return true;
      // }
      // evt.preventDefault();
      // try {
      //   text = await navigator.clipboard.readText();
      // } catch (error) {
      //   // console.log("Failed to read clipboard contents: ", error);
      // }
      // if (this.maxlength && text.length > this.maxlength) {
      //   return true;
      // }
      // if (text && this.regex.test(text)) {
      //   evt.target.value = text;
      //   this.$emit("update:model", text);
      // }
    },
    onFocus(event) {
      this.$emit("focus", event);
    },
    onBlur(event) {
      this.$emit("blur", event);
    },
    validateFormat(evt) {
      let theEvent = evt || window.event;
      if (this.regex) this.allowFormat(theEvent);
    },
    allowFormat(evt) {
      // Handle paste
      let key;
      if (evt.ctrlKey) {
        return true;
      }
      key = evt.key;
      if (evt.keyCode == 8) {
        return true;
      }
      if (!this.regex.test(key)) {
        evt.returnValue = false;
        if (evt.preventDefault) evt.preventDefault();
      }
    },
    handleInput(e) {
      if (!this.isRealtimeValidate) {
        this.$emit("update:error", false);
        e.target.classList.remove("invalid");
      }
      let value = e.target.value;
      if (this.isUpperCase && typeof value === "string") {
        value = value.toUpperCase();
      }
      if (this.isLowerCase && typeof value === "string") {
        value = value.toLowerCase();
      }
      if (value && this.isMoney) {
        value = value.replace(/\./g, "");
      }
      if (this.regex && !this.regex.test(value)) {
        value = null;
      }
      this.$emit("update:model", value);
      this.$emit("input", value);
      this.$emit("action");
    },
    updateParent(e) {
      this.$emit("update:error", false);
      e.target.classList.remove("invalid");
      let value = e.target.value;
      if (value && this.isMoney) {
        value = value.replace(/\./g, "");
      }
      this.$emit("update:model", value);
    },
    _formatCurrencyInput: _formatCurrencyInput
  }
};
</script>
<style lang="scss" scoped>
input {
  &.border-success {
    border: solid thin #0da313;
  }
}
</style>